import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ExpandedListTab from '../ExpandedListTab';
import useExtendedQuery from '../../hooks/useExtendedQuery';
import {
    AMQP,
    REDECLARE_AMQP_EXCHANGES,
} from '../../graphql/settings';
import useExtendedMutation from '../../hooks/useExtendedMutation';
import MutationButton from '../buttons/MutationButton';
import DateTime, { DATETIME } from '../DateTime';
import ReadonlyField from '../fields/ReadonlyField';
import Spinner from '../Spinner';
import Error from '../errors/Error';
import AmqpVhostsTable from './AmqpVhostsTable';

function AmqpDetailTab() {
    const { t } = useTranslation();
    const {
        loading,
        error,
        data,
    } = useExtendedQuery(AMQP);
    const redeclareAmqpExchangesMutation = useExtendedMutation(REDECLARE_AMQP_EXCHANGES, {
        successMessageOptions: { key: 'settings.amqp.redeclare-exchanges-success', dataProperty: 'redeclareAmqpExchanges' },
        failureMessageOptions: { key: 'settings.amqp.redeclare-exchanges-failure' },
        withCorrelationId: false,
    });
    let result;
    if (loading) {
        result = <Spinner className="amqp-loading" />;
    } else if (error) {
        result = <Error className="amqp-error" error={error} />;
    } else if (data.amqp.lastRequestTime === null && data.amqp.virtualHosts === null) {
        result = <div className="amqp-not-configured">{t('settings.amqp-not-configured')}</div>;
    } else {
        result = (
            <>
                <div className="rich-list-row-expanded--fields">
                    <ReadonlyField
                        label={t('settings.amqp.last-request-time')}
                        value={data.amqp.lastRequestTime ? <DateTime value={data.amqp.lastRequestTime} format={DATETIME} /> : t('misc.na')}
                        className="amqp-detail-tab--fields--last-request-time"
                    />
                    <AmqpVhostsTable vhosts={data.amqp.virtualHosts} />
                </div>
                <div className="rich-list-row-expanded--buttons">
                    <div className="rich-list-row-expanded--buttons--left">
                        <MutationButton
                            className="redeclare-exchanges-button button-bordered button"
                            confirmationMessage={t('settings.amqp.redeclare-exchanges-confirmation-message')}
                            extendedMutation={redeclareAmqpExchangesMutation}
                            showConfirmationDialog
                        >
                            <FontAwesomeIcon icon="bullhorn" />&nbsp;{t('settings.amqp.redeclare-exchanges-button')}
                        </MutationButton>
                    </div>
                </div>
            </>
        );
    }
    return (
        <ExpandedListTab
            className="settings-detail-tab"
        >
            {result}
        </ExpandedListTab>
    );
}

export default AmqpDetailTab;
